<template>
  <BaseModal
    :show="isOpen"
    size="sm"
    :title="t('app.views.cashRegister.addExpense') || 'Add Expense'"
    :show-actions="true"
    :save-text="t('app.actions.save') || 'Save'"
    @close="$emit('close')"
    @save="handleSave"
  >
    <div class="space-y-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
          {{ t('app.views.cashRegister.expenseAmount') || 'Amount' }}
        </label>
        <input 
          v-model="localAmount" 
          type="number" 
          step="0.01" 
          min="0"
          class="w-full rounded-md border border-gray-300 dark:border-gray-700 dark:bg-gray-800 dark:text-white px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500"
        >
      </div>
        
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
          {{ t('app.views.cashRegister.expenseDescription') || 'Description' }}
        </label>
        <input 
          v-model="localDescription" 
          type="text"
          class="w-full rounded-md border border-gray-300 dark:border-gray-700 dark:bg-gray-800 dark:text-white px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500"
        >
      </div>
    </div>
  </BaseModal>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseModal from '@/components/common/BaseModal.vue';

const { t } = useI18n();

const props = defineProps<{
  isOpen: boolean;
  amount: number;
  description: string;
}>();

const emit = defineEmits<{
  close: [];
  save: [data: { amount: number; description: string }];
}>();

const localAmount = ref(props.amount);
const localDescription = ref(props.description);

watch(() => props.amount, (newVal) => localAmount.value = newVal);
watch(() => props.description, (newVal) => localDescription.value = newVal);

const handleSave = () => {
  emit('save', {
    amount: localAmount.value,
    description: localDescription.value
  });
};
</script>
